import httpClient, { PROJECT_HEADER } from '@xver/libs/axios';

import {
    GetContainerCostResponse,
    GetContainerQuotaResponse,
    PrerequisiteResponseModel,
} from './model';

const ENDPOINTS = {
    PREREQUISITE: '/v1/containers/prerequisite',
    ACTIVATE: '/v1/containers/activate',
    QUOTA: (id: string) => `/v1/containers/${id}/quota`,
    COST: (id: string) => `/v1/containers/${id}/cost`,
};

/** `personal` checks the caller's own Harbor account instead of the active project owner's. */
export function getPrerequisite({ personal = false } = {}): Promise<PrerequisiteResponseModel> {
    return httpClient.get(
        ENDPOINTS.PREREQUISITE,
        personal ? { headers: { [PROJECT_HEADER]: '' } } : undefined
    );
}

export function activate(): Promise<null> {
    return httpClient.post(ENDPOINTS.ACTIVATE);
}

export function getContainerQuota(id: string): Promise<GetContainerQuotaResponse> {
    return httpClient.get(ENDPOINTS.QUOTA(id));
}

export function getContainerCost(id: string): Promise<GetContainerCostResponse> {
    return httpClient.get(ENDPOINTS.COST(id));
}
